export default "__VITE_ASSET__CW2$kUAQ__"